export default __webpack_public_path__ + "static/404-tablet-3c69512ed5f82bf8162775abf1d5c3e6.webp";